<div class="spinner">
  @for (n of 5 | repeat; track n) {
    <div class="rect" [ngClass]="getRectClass(n)"></div>
  }
</div>
